import { Integration_Handler_Names_Enum } from '@main/graphql/types.generated';
import { z } from 'zod/v4';

import { IntegrationConfig } from '../../../../../../lib';
import { WafService } from '../../service';

export type WebAclAssociationConfig = typeof WebAclAssociationConfig._.Config;

export const WebAclAssociationConfig = IntegrationConfig.make({
  service: WafService,
  name: Integration_Handler_Names_Enum.WebAclAssociation,
  configSchema: z.object({
    resourceArns: z.array(z.string().min(1)).min(1),
    blockActionRequired: z.boolean().optional(),
  }),
});
